var _excluded = ["status", "className"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useControllableValue } from 'ahooks';
import { Slider as AntdSlider, Form, InputNumber } from 'antd';
import { useTheme } from 'antd-style';
import classNames from 'classnames';
import { getClearIcon } from "../Input";
import useStyle, { useSlideBindInputStyles } from "./style/index";
var Slider = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useTheme = useTheme(),
    prefixCls = _useTheme.prefixCls;
  var _useStyle = useStyle(props),
    styles = _useStyle.styles;
  var status = props.status,
    className = props.className,
    resetProps = _objectWithoutProperties(props, _excluded);
  var cls = classNames("".concat(prefixCls, "-slider-").concat(status), className, styles.sliderWrap);
  // const cls = classNames(`${prefixCls}-slider-${status}`, className);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AntdSlider, _extends({
    ref: ref
  }, resetProps, {
    className: cls
  })));
});
Slider.displayName = 'Slider';
var SliderBindInput = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useTheme2 = useTheme(),
    prefixCls = _useTheme2.prefixCls;
  var _useSlideBindInputSty = useSlideBindInputStyles(props),
    styles = _useSlideBindInputSty.styles;
  // controlled value and not controlled value
  var _useControllableValue = useControllableValue(props),
    _useControllableValue2 = _slicedToArray(_useControllableValue, 2),
    bindState = _useControllableValue2[0],
    setbindState = _useControllableValue2[1];
  var token = useTheme();
  var _Form$Item$useStatus = Form.Item.useStatus(),
    antdFormItemStatus = _Form$Item$useStatus.status;
  var inputProps = props.inputProps,
    className = props.className,
    style = props.style,
    sliderProps = props.sliderProps,
    defaultValue = props.defaultValue,
    status = props.status,
    _props$min = props.min,
    min = _props$min === void 0 ? 0 : _props$min,
    _props$max = props.max,
    max = _props$max === void 0 ? 100 : _props$max;

  // user status is the highest priority, form item status is the second
  var finalStatus = status || antdFormItemStatus;
  var handleInputChange = function handleInputChange(value) {
    setbindState(value);
  };
  var handleSliderChange = function handleSliderChange(value) {
    setbindState(value);
  };
  var cls = classNames("".concat(prefixCls, "-slider-bind-input"), className, styles.wrap);
  var inputCls = classNames("".concat(prefixCls, "-slider-input"), styles.sliderInput, sliderProps === null || sliderProps === void 0 ? void 0 : sliderProps.className);
  var sliderCls = classNames("".concat(prefixCls, "-slider"), styles.slider, inputProps === null || inputProps === void 0 ? void 0 : inputProps.className);
  var clearIcon = getClearIcon(function () {
    setbindState(null);
  }, token);
  var SuffixNode = /*#__PURE__*/React.createElement("span", {
    className: styles.suffix
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.clear
  }, clearIcon), /*#__PURE__*/React.createElement("span", {
    className: styles.unit
  }, "%"));
  return /*#__PURE__*/React.createElement("div", {
    className: cls,
    style: style
  }, /*#__PURE__*/React.createElement(Slider, _extends({
    status: finalStatus,
    min: min,
    max: max,
    onChange: handleSliderChange,
    value: typeof bindState === 'number' ? bindState : 0
  }, sliderProps, {
    className: sliderCls
  })), /*#__PURE__*/React.createElement("div", {
    className: inputCls
  }, /*#__PURE__*/React.createElement(InputNumber, _extends({
    min: min,
    max: max,
    defaultValue: defaultValue,
    value: bindState,
    controls: false,
    onChange: handleInputChange
  }, inputProps)), SuffixNode));
});
SliderBindInput.displayName = 'SliderBindInput';
export default Slider;
export { SliderBindInput };